import { auth } from "./firebaseConfig";

export function getBackendUrl() {
  return (
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "") ||
    "http://localhost:5000"
  );
}

export async function parseJsonSafe(response) {
  const text = await response.text();
  if (!text || !text.trim()) return null;
  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(
      "API returned non-JSON response:",
      response.url,
      text.slice(0, 120)
    );
    return null;
  }
}

export async function getAuthHeaders(extra = {}) {
  const headers = { ...extra };
  const currentUser = auth.currentUser;
  if (currentUser) {
    const token = await currentUser.getIdToken();
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function authFetch(url, options = {}) {
  const headers = await getAuthHeaders(options.headers || {});
  return fetch(url, { ...options, headers });
}
